export function timeAgo (time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), '分')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), '时')
  } else if (between < 111111259200) {
    return pluralize(~~(between / 86400), '天')
  } else {
    return formatTime(time)
  }
}
export function formatTime (obj) {
  var date = new Date()
  date.setTime(obj * 1000)
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()

  return [year, month, day].map(formatNumber).join('-') + ' ' + [].map(formatNumber).join(':')
}

export function formatMonth (obj) {
  var date = new Date()
  date.setTime(obj * 1000)
  var month = date.getMonth() + 1
  var day = date.getDate()

  return [month, day].map(formatNumber).join('-')
}

function formatNumber (n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}

function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label
}

export function orderStatus(val) {
  switch (Number(val)) {
    case 10:
      return "待发货"
    case 20:
      return "待收货"
    case 30:
      return "已完成"
    case 40:
      return "已关闭"
  }
}

export function integralType(val) {
  switch (Number(val)) {
    case 10:
      return "商品积分"
    case 20:
      return "兑换"
    case 30:
      return "退还"
    case 40:
      return "充值"
    case 50:
      return "扣减"
  }
}